import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Grid, Row, Col } from 'react-flexbox-grid'
import FormNewProject from '../../containers/FormNewProject'
import EditableTableProjects from '../../containers/EditableTableProjects'
import * as Constants from '../../../constants'
import { db } from '../../../config/Fire'
import { Divider } from 'antd'
import Search from 'antd/lib/input/Search'
import { getUser } from '../../../reducers'
import './styles.css'

const projectsRef = db.ref(`${Constants.MAIN_NODES.PROJECTS}`)

function compareName(a, b) {
	// Validar que ambos objetos existan
	if (!a && !b) return 0
	if (!a) return 1
	if (!b) return -1

	// Validar que name exista y sea string, con conversión segura
	let nameA = ''
	let nameB = ''

	if (a && a.name != null) {
		nameA = String(a.name).toLowerCase()
	}
	if (b && b.name != null) {
		nameB = String(b.name).toLowerCase()
	}

	if (nameA < nameB) {
		return -1
	}
	if (nameA > nameB) {
		return 1
	}
	return 0
}

class Projects extends Component {
	state = {
		projectsMap: {},
		projectsFiltered: []
	}

	componentDidMount() {
		this.getData()
	}

	getData = () => {
		projectsRef.on('value', (projectsSnap) => {
			const projectsLoaded = {}
			if (projectsSnap.exists() && projectsSnap.val() !== null) {
				projectsSnap.forEach(projectSnap => {
					const project = projectSnap.val()
					// Solo mostrar proyectos activos (isActive === true)
					if (project && project.id && project.isActive === true) {
						projectsLoaded[project.id] = project
					}
				})
			}
			if (this.searchInput && this.searchInput.input && this.searchInput.input.state) {
				this.searchInput.input.state.value = ''
			}
			// Inicializar projectsFiltered con los proyectos cargados para evitar llamar searchProject en el render
			const projectsArray = Object.keys(projectsLoaded)
				.map(key => projectsLoaded[key])
				.filter(project => project != null && project.name != null && project.name !== undefined)
			projectsArray.sort(compareName)
			this.setState({ projectsMap: projectsLoaded, projectsFiltered: projectsArray }, () => { })
		}, (error) => {
			console.error('Error al cargar proyectos:', error)
		})
	}

	componentWillUnmount() {
		projectsRef.off('value')
	}

	renderProjectsTable = projectsFiltered => {
		var data = []
		// Manejar tanto arrays como objetos
		const projectsArray = Array.isArray(projectsFiltered)
			? projectsFiltered
			: Object.keys(projectsFiltered).map(projectKey => projectsFiltered[projectKey])

		projectsArray.forEach(project => {
			if (project && project.name != null && project.isActive === true) {
				data.push({
					...project,
					id: project.id,
					name: project.name,
					latitude: project.latitude,
					longitude: project.longitude,
					travelHours: project.travelHours || 0,
					createDate: project.createDate,
					isActive: project.isActive
				})
			}
		})
		// Filtrar elementos inválidos antes de ordenar
		data = data.filter(item => item != null && item.name != null && item.isActive === true)
		data.sort(compareName)
		return (<EditableTableProjects data={data} showEditButton={true} />)
	}

	searchProject = (value) => {
		const { projectsMap } = this.state
		if (projectsMap) {
			var projectsData = []
			for (var key in projectsMap) {
				const project = projectsMap[key]
				// Filtrar proyectos válidos con name definido y isActive === true
				if (project && project.name != null && project.name !== undefined && project.isActive === true) {
					if (value === '' ||
						(project.name && String(project.name).toLowerCase().indexOf(value.toLowerCase()) !== -1)) {
						projectsData.push(project)
					}
				}
			}
			// Filtrar cualquier elemento null/undefined antes de ordenar
			projectsData = projectsData.filter(project => project != null && project.name != null && project.isActive === true)
			projectsData.sort(compareName)
			this.setState({ projectsFiltered: projectsData })
		}
	}

	render() {
		const { projectsMap, projectsFiltered } = this.state
		return (
			<div>
				<Grid className="usersCont">
					<Divider>Nuevo proyecto</Divider>
					<Row center="xs">
						<Col xs={12}>
							<FormNewProject />
						</Col>
					</Row>
					<Divider>Proyectos</Divider>
					<Row center="xs">
						<Col xs={10} sm={6}>
							<Search ref={txt => this.searchInput = txt} style={{ marginBottom: '20px' }}
								placeholder="Nombre del proyecto"
								onSearch={(value) => this.searchProject(value)} enterButton />
						</Col>
					</Row>
					<Row center="xs">
						<Col xs={12}>
							{this.renderProjectsTable(projectsFiltered)}
						</Col>
					</Row>
				</Grid>
			</div>
		)
	}
}

Projects.propTypes = {}

const mapStateToProps = state => ({
	user: getUser(state)
})

export default connect(mapStateToProps)(Projects)

